import React from "react";
import UnauthorizedContent from "@/components/organisms/UnauthorizedContent.jsx";

function Unauthorized() {
  return <UnauthorizedContent />;
}

export default Unauthorized;
